import React, { useEffect, useState } from 'react'
import { useModal } from '../../hooks';
import LavorisService from '../../services/LavorisService';
import { useAlert } from '../../hooks/useAlert';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/combineReducer';
import { SelectedFiles } from '../../components/others/FileUploader/FileUploader.types';
import { useForm } from 'react-hook-form';
import { getErrorMessage } from '../../utils';
import { Modal } from '../../components/others/Modal';
import { Input } from '../../components/core/Input';
import { Button } from '../../components/core/Button';
import Select from '../../components/others/Select/Select';
import { PhoneNumber } from '../../utils/phoneNumber';
import SearchSelectFetch from '../../components/others/SearchFetch';
import { fetchAndFilterMoldes, fetchAndFilterPractices } from '../others/requestTurn/utils';
import { PillButton } from '../../components/others/PillButton';
import Textarea from '../../components/others/Textarea/Textarea';
import DynamicFileUpload from '../../components/others/DynamicFileUpload';
import FileUpload from '../../components/others/FileUploader/FileUploader';
import { PrimaryButton } from '../../components/others/ButtonPrimary';
import { ExamDetails, MoldeDetails, PracticesPillows } from '../others/AppointmentMetadata';
import { Practice } from '../../services/TurnServices/Turns.type';
import InputRadio from '../../components/others/InputRadio/InputRadio';

const REQUEST_ABSENTEE_IN_LAVORIS_MODAL = "requesAbsenteeInLavorisModal";
const SUCCESS = 'succesPetition';

const NewRequestModal = ({ onClose, refreshFunction }: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { closeModal, openModal } = useModal();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]?.id);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('Empleado')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);


    const searchUser = async () => {
        setSearchLoading(true)
        try {
            setSelectedEmployee(null)
            const response = await LavorisInstance.CompanyServices.getEmployeeWithQuery(currentCompany, searchData, signal);
            const data = Array.isArray(response) ? response : response;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }

    }

    useEffect(() => {
        return () => {
            controller.abort()
        };
    }, [])

    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient, molde, exam, practicesSelected] = watch([
        'patient',
        "molde",
        "exam",
        "practicesSelected",
    ]);

    useEffect(() => {

        const normalizeString = (str: any) => {
            return str
                .trim()                    // Eliminar espacios al inicio y al final
                .replace(/\s+/g, ' ')      // Reemplazar múltiples espacios por uno solo
                .toLowerCase();            // Convertir a minúsculas
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });


        setSelectedEmployee(chosenEmployee);
    }, [patient]);



    ///Funciones para la carga de archivos

    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };
    /******************************************************/



    // OnSubmit
    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            const metadata = {
                exam: exam?.id,
                molde: molde?.id,
                practices: practicesSelected?.map((p: Practice) => p.id),
            };

            if (metadata.exam === undefined && metadata.molde === undefined && (metadata.practices === undefined || metadata.practices.length === 0)) {
                showAlert('Debe elegir un examen o una práctica para continuar')
                return;
            }

            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = 'COMPANY_EMPLOYEE';
            const dataToSubmit = {
                observations: data.comments,
                patientType,
                patientId,
                metadata,
            };

            const res = await LavorisInstance.TurnServices.RequestAbsenteeTurnService(dataToSubmit)

            const filesToUpload = selectedFiles?.profileImages ?? [];
            if (res && filesToUpload.length) {
                await Promise.all(
                    filesToUpload.map((file) => uploadFile(res.appointment, file)),
                );
            }
            closeModal(REQUEST_ABSENTEE_IN_LAVORIS_MODAL)
            refreshFunction?.()
            openModal(SUCCESS);
        } catch (err) {
            console.log(err)
            showAlert(getErrorMessage({ title: 'NO SE PUDO REALIZAR LA SOLICITUD.', err }))
        } finally {
            setRequestLoading(false);
        }
    };


    return (
        <div>
            <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                <div className='flex gap-2 justify-start align-middle w-auto'>
                    <Input
                        type='text'
                        fieldName='searchuser'
                        label='Buscar por apellido,nombre o dni'
                        register={register}
                        //required
                        style={{ width: '300px', height: '80px' }}
                        onChange={(e: any) => setSearchData(e.target.value)}
                    />
                    <Button
                        type='button'
                        text='Buscar'
                        className='bg-green-700 text-lg text-white h-auto text-center p-auto m-auto'
                        onClick={searchUser}
                        disabled={searchLoading}
                    />
                </div>
                {
                    usersFound?.length > 0 ? (
                        <Select
                            fieldName="patient"
                            styles="w-full rounded-md h-12"
                            register={register}
                            label={`Seleccionar ${type}`}
                            required={true}
                            error={errors?.patient}
                            options={usersFound}

                        />
                    ) : usersFound?.length === 0 ? (
                        <div className='flex justify-center align-middle'>
                            <h2>Sin resultados</h2>
                        </div>
                    ) : null
                }
                <div className="flex gap-4">
                    {selectedEmployee && selectedEmployee !== undefined ? (
                        <>
                            <div className="flex flex-col ">
                                <p>Paciente</p>
                                <p>DNI</p>
                                <p>Teléfono</p>
                                <p>Email</p>
                            </div>
                            <div>
                                <p className="font-semibold">
                                    {selectedEmployee?.name || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {selectedEmployee?.DNI || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {selectedEmployee?.email || "N/A"}
                                </p>
                            </div>
                        </>
                    ) : undefined}
                </div>
                {
                    selectedEmployee && selectedEmployee !== undefined && (
                        <>

                            <>
                                {/* <div className="my-5">
                                    <SearchSelectFetch
                                        control={control}
                                        name="molde"
                                        label="Puestos (Exámenes sugeridos)"
                                        disabled={Boolean(exam)}
                                        fetchOptions={async () => {
                                            return fetchAndFilterMoldes(
                                                LavorisInstance,
                                                currentCompany?.id ? currentCompany.id : currentCompany,
                                                type,
                                                true,
                                            );
                                        }}
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                    />
                                    {molde && (
                                        <div className="my-5">
                                            <div className="mb-6">
                                                <PillButton
                                                    text={molde.name || molde.position.name}
                                                    onClick={() => resetField("molde")}
                                                />
                                            </div>
                                            <MoldeDetails molde={molde} />
                                        </div>
                                    )}
                                </div> */}
                                {/* <SearchSelectFetch
                                    control={control}
                                    name="exam"
                                    label="Examen"
                                    fetchOptions={async () =>
                                        LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                                            type,
                                        )
                                    }
                                    propertyLabel={"name"}
                                    inputStyles="rounded w-full h-[50px]"
                                    disabled={Boolean(molde)}
                                />
                                {exam && (
                                    <div className="mb-6">
                                        <div className="mb-6">
                                            <PillButton
                                                key={`exam-${exam.id}`}
                                                text={exam.name}
                                                onClick={() => resetField("exam")}
                                            />
                                        </div>
                                        <ExamDetails exam={exam} />
                                    </div>
                                )} */}
                            </>

                            < SearchSelectFetch
                                control={control}
                                name="practiceSelector"
                                label="Prácticas individuales"
                                fetchOptions={async () => {
                                    return fetchAndFilterPractices(
                                        LavorisInstance,
                                        exam,
                                        molde,
                                        practicesSelected,
                                        type,
                                        true
                                    );
                                }}
                                propertyLabel={"name"}
                                inputStyles="rounded w-full h-[50px]"
                                onSelected={(data) => {
                                    const selected = practicesSelected?.length
                                        ? practicesSelected
                                        : [];
                                    setValue("practicesSelected", [...selected, data]);
                                }}
                            />
                            {practicesSelected?.length >= 0 && (
                                <PracticesPillows
                                    practices={practicesSelected}
                                    onClick={(practice: Practice) => {
                                        setValue(
                                            "practicesSelected",
                                            practicesSelected.filter((p: any) => p.id !== practice.id),
                                        );
                                    }}
                                />
                            )}

                            <Textarea
                                fieldName="comments"
                                label="Comentarios"
                                register={register}
                                error={errors?.comments}
                                styles="rounded w-full mb-4"
                                rows={8}
                            />
                            <DynamicFileUpload
                                label="Cargar archivo (Opcional)"
                                updateFilesCb={updateUploadedFiles}
                                maxFileSizeInBytes={500000}
                                accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                multiple
                                buttonText="Agregar otro archivo"
                            />


                            <div className="w-52 m-auto">
                                <PrimaryButton
                                    type="submit"
                                    text={'Solicitar turno'}
                                    styles="bg-red-500 font-bold text-white mt-3"
                                    disabled={requestLoading}
                                />
                            </div>


                        </>

                    )
                }


            </form>
        </div>

    )
}

const NewRequestPrestadorModal = ({ onClose, refreshFunction }: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [type, setType] = useState<string>('Empleado')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]?.id);

    const searchUser = async () => {
        setSearchLoading(true)
        try {

            setSelectedEmployee(null)
            const response = await LavorisInstance.CompanyServices.getEmployeeWithQuery(currentCompany, searchData, signal);

            const data = Array.isArray(response) ? response : response;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }

    }

    useEffect(() => {
        return () => {
            controller.abort()
        };
    }, [])


    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient] = watch(['patient'])

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()                    // Eliminar espacios al inicio y al final
                .replace(/\s+/g, ' ')      // Reemplazar múltiples espacios por uno solo
                .toLowerCase();            // Convertir a minúsculas
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });


        setSelectedEmployee(chosenEmployee);
    }, [patient]);





    /****Funciones para la carga de archivos***/
    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };
    /******************************************************/



    // OnSubmit
    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {

            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = 'COMPANY_EMPLOYEE';
            const dataToSubmit = {
                observations: data.comments,
                patientType: patientType,
                patientId,
            };

            const res = await LavorisInstance.TurnServices.RequestPrestadorTurnService(dataToSubmit)

            if (res && selectedFiles?.profileImages[0]) {
                await uploadFile(
                    res.appointment,
                    selectedFiles.profileImages[0],
                );
            }
            showAlert('Su solicitud fue creada correctamente')
            onClose()
            refreshFunction()
        } catch (err) {
            showAlert(getErrorMessage({ title: 'No se pudo realizar la solicitud.', err }))
        } finally {
            setRequestLoading(false);
        }
    };


    return (


        <div>
            <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                <div className='flex gap-2 justify-start align-middle w-auto'>
                    <Input
                        type='text'
                        fieldName='searchuser'
                        label='Buscar por apellido,nombre o dni'
                        register={register}
                        required
                        style={{ width: '300px' }}
                        onChange={(e: any) => setSearchData(e.target.value)}
                    />
                    <Button
                        type='button'
                        text='Buscar'
                        className='bg-green-700 text-lg text-white h-[50px] text-center p-auto m-auto'
                        onClick={searchUser}
                        disabled={searchLoading}
                    />
                </div>
                {
                    usersFound?.length > 0 ? (
                        <Select
                            fieldName="patient"
                            styles="w-full rounded-md h-12"
                            register={register}
                            label={`Seleccionar ${type}`}
                            required={true}
                            error={errors?.patient}
                            options={usersFound}

                        />
                    ) : usersFound?.length === 0 ? (
                        <div className='flex justify-center align-middle'>
                            <h2>Sin resultados</h2>
                        </div>
                    ) : null
                }
                <div className="flex gap-4">
                    {selectedEmployee && selectedEmployee !== undefined ? (
                        <>
                            <div className="flex flex-col ">
                                <p>Paciente</p>
                                <p>DNI</p>
                                <p>Teléfono</p>
                                <p>Email</p>
                                <p>Dirección</p>
                            </div>
                            <div>
                                <p className="font-semibold">
                                    {selectedEmployee?.name || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {selectedEmployee?.DNI || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {selectedEmployee?.email || "N/A"}
                                </p>
                                <p className="font-semibold">
                                    {selectedEmployee?.fullAddress || "N/A"}
                                </p>
                            </div>
                        </>
                    ) : undefined}
                </div>
                {
                    selectedEmployee && selectedEmployee !== undefined && (
                        <>
                            <div className="flex flex-col gap-1 justify-center align-middle">
                                <label className="text-center text-xl text-red-600 font-extrabold underline">INFORMACIÓN OBLIGATORIA</label>
                                <ul className="list-disc pl-6">
                                    <li>Ubicación actual del {type === 'Postulante' ? 'postulante' : 'empleado'} (ciudad, localidad y provincia)</li>
                                    <li>{type === 'Postulante' ? 'Examen Ingreso' : 'Examen Periódico o Egreso'}, prácticas</li>
                                </ul>
                            </div>

                            <Textarea
                                fieldName="comments"
                                label="Comentarios"
                                register={register}
                                error={errors?.comments}
                                styles="rounded w-full mb-4"
                                rows={8}
                            />
                            <FileUpload
                                label="Cargar archivo (Opcional)"
                                updateFilesCb={updateUploadedFiles}
                                maxFileSizeInBytes={500000}
                                accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            //multiple
                            />


                            <div className="w-52 m-auto">
                                <PrimaryButton
                                    type="submit"
                                    text={'Solicitar turno'}
                                    styles="bg-red-500 font-bold text-white mt-3"
                                    disabled={requestLoading}
                                />
                            </div>


                        </>

                    )
                }


            </form>
        </div>




    )
}









const RequestTurnsEmployeesInLavoris = ({ show, modalTitle, urlTittle, onClose, refreshFunction }: any) => {
    const styles = "text-2xl text-red-500 font-bold";
    const {
        register,
        watch,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });


    const [where, setWhere] = useState<string>('Clínica Lavoris')

    return (
        <Modal
            show={show}
            modalTitle={modalTitle}
            urlTittle={urlTittle}
            onClose={onClose}
            titleStyle={styles}
        >
            <div>
                {/* <div className="flex items-center my-3">
                    <InputRadio
                        label="Seleccionar dónde realizar el control"
                        fieldName="whereSelection"
                        option1="Clínica Lavoris"
                        option2="Clínica externa"
                        onChange={(e: any) => setWhere(e)}
                        register={register}
                        defaultValue={'Clínica Lavoris'}
                        error={errors?.whereSelection}
                    />
                </div> */}
                <NewRequestModal onClose={onClose} refreshFunction={refreshFunction} />
                {/* {where === 'Clínica Lavoris' && (<NewRequestModal onClose={onClose} refreshFunction={refreshFunction} />)}
                {where === 'Clínica externa' && (<NewRequestPrestadorModal onClose={onClose} refreshFunction={refreshFunction} />)} */}
            </div>


        </Modal>
    )
}

export default RequestTurnsEmployeesInLavoris